<template>
  <div class="notification" :class="classType">
    <button class="delete" @click="$emit('onDelete')"></button>
    <h1 v-if="title" class="title is-5">{{ title }}</h1>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: undefined },
    message: { type: String, default: undefined },
    type: { type: String, default: 'info' },
    sticky: { type: Boolean, default: false },
    timeout: { type: Number, default: 4000 }
  },
  computed: {
    classType () {
      switch (this.type) {
        case 'error': return 'is-danger'
        case 'success': return 'is-success'
        case 'info':
        default: return 'is-info'
      }
    }
  },
  mounted () {
    if (!this.sticky) {
      setTimeout(() => { this.$emit('onTimeout') }, this.timeout)
    }
  }
}
</script>
